// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"ProductDetails_contentSection__Bp9F2"};